import { get, maxBy } from 'lodash-es'
import getPriorityBsClass from '@therms/web-common/components/Priority/getPriorityBsClass'

export const getHighPriorityPendingServiceCall = dispatchRecords =>
  get(maxBy(dispatchRecords, 'fields.priority'), 'fields.priority')

export const getPendingServiceCallHighestPriorityBsClass = dispatchRecords =>
         getPriorityBsClass(getHighPriorityPendingServiceCall(dispatchRecords))
